import { useEffect, useState } from "react";
import axios from "axios";
import { FiImage } from "react-icons/fi";
import styles from "../../styles/home.module.css";
import ProductImage from "../ProductImage";
import bestSellingImg from "../../assets/best-selling.jpeg";

const BESTSELLING_ITEM = { key: "bestselling", label: "الأكثر مبيعاً", localImage: bestSellingImg };

const CategoriesSection = ({ activeTab, onSelect }) => {
  const [categories, setCategories] = useState([]);

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_BACKEND_URL}/api/categories`)
      .then((res) => setCategories(res.data ?? []))
      .catch(() => {});
  }, []);

  const items = [
    BESTSELLING_ITEM,
    ...categories.map((cat) => ({ key: cat.id, label: cat.name, imageUrl: cat.imageUrl })),
  ];

  return (
    <section className={styles.section}>
      <h2 className={styles.sectionTitle}>اختر حسب الستايل</h2>

      <div className={styles.cats}>
        {items.map((item) => (
          <button
            key={item.key}
            type="button"
            onClick={() => onSelect(item.key, item.label)}
            className={activeTab === item.key ? `${styles.catItem} ${styles.catActive}` : styles.catItem}
          >
            <div className={styles.catCircle}>
              <div className={styles.catInner}>
                {item.localImage ? (
                  <img src={item.localImage} alt={item.label} className={styles.catImg} />
                ) : item.imageUrl ? (
                  <ProductImage url={item.imageUrl} alt={item.label} className={styles.catImg} />
                ) : (
                  <FiImage className={styles.catPlaceholder} />
                )}
              </div>
            </div>
            <span className={styles.catLabel}>{item.label}</span>
          </button>
        ))}
      </div>
    </section>
  );
};

export default CategoriesSection;
